import { render, staticRenderFns } from "./prefolders.vue?vue&type=template&id=93ebe90a"
import script from "./prefolders.vue?vue&type=script&lang=js"
export * from "./prefolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports